// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__nLLLg","column":"Section_column__2iNlw"};